export class ContentDetail {
  id: string;
  author?: string;
  title?: string;
  titleHtml?: string;
  highlight?: string;
  highlightHtml?: string;
  detail?: string;
  detailHtml?: string;
  rank: number;
  contentType?: string;
  hidden = false;
}

export enum ContentMessageDetailType {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  READER = 'reader',
  WIDE = 'wide',
  AUTO = 'auto',
  AUTO_SMALL = 'auto-small',
  AUTO_MEDIUM = 'auto-medium',
  AUTO_LARGE = 'auto-large',
  AUTO_READER = 'auto-reader',
  AUTO_WIDE = 'auto-wide',
  FULL = 'full'
}

export interface ContentDetailMessage {
  id: string;
  contentDetail: ContentDetail;
  messageType?: ContentMessageDetailType;
}

export interface ContentDetails {
  id: string;
  title: string;
  titleHtml: string;
  description?: string;
  descriptionHtml?: string;
  author?: string;
  authorHtml?: string;
  details?: Array<ContentDetail>;
  publishedAt?: Date;
}



// WEBPACK FOOTER //
// ./src/app/model/typings/content.types.ts